export default "__VITE_ASSET__BVIJVgap__"